import { Button } from "@/shadcn/components/ui/button";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/shadcn/components/ui/hover-card";
import { Notebook } from "lucide-react";
import React from "react";

type NoteHoverCardProps = {
  note: string;
};

const NoteHoverCard: React.FC<NoteHoverCardProps> = ({ note }) => {
  return (
    <HoverCard openDelay={200} closeDelay={200}>
      <HoverCardTrigger asChild>
        <Button variant="ghost">
          <Notebook className="h-5 w-5" />
        </Button>
      </HoverCardTrigger>
      <HoverCardContent
        className="w-auto max-w-64 border-none bg-transparent p-0 text-sm shadow-none"
        style={{ boxShadow: "none", background: "none" }}
      >
        <div
          className="bg-secondary flex min-h-12 items-center gap-2 rounded-lg border p-3 shadow-md"
          style={{
            wordBreak: "break-word",
            whiteSpace: "pre-wrap",
          }}
        >
          <Notebook className="mt-0.5 h-4 w-4 shrink-0" />
          <span className="" style={{ flex: 1 }}>
            {note}
          </span>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};

export default NoteHoverCard;
